module.exports = __webpack_public_path__ + "img/DSC09241.945d3964.webp";